require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./venir-pour-un-projet-2-5-1-1.json") })
        }
      }, "path---venir-pour-un-projet-2-5-1-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---venir-pour-un-projet-2-5-1-1!./.cache/json/venir-pour-un-projet-2-5-1-1.json
// module id = 600
// module chunks = 231608221292675